import { BLACK, GRAY_300, GRAY_400, PRIMARY_600 } from "../../constant/colors";
import { fontWeights, sizes } from "../../constant/styles";

// Shared Figma Design Overrides for PatientView Tables
// This style is applied on top of the base TableStyle for all tables within PatientView
export const PatientViewTableStyle = `  
  /* Remove previous borders and apply new ones */
  .ant-table {
    border: none !important;
    border-radius: 10px;
  }

  .ant-table-container {
    border-radius: 10px;
  }

  /* Update header background color and font style */
  .ant-table-thead {
    background: #f2f4f7 !important;
  }

      .ant-table-thead > tr > .ant-table-cell,
      .ant-table-thead > tr > th {
        background: #f2f4f7 !important;
        color: ${BLACK};
        font-weight: ${fontWeights.semibold};
        font-size: ${sizes.medium};
        line-height: 150%;
        height: 41px !important;
        padding: 9.5px 8px !important;
        border-bottom: none !important;
        border-top: 1px solid #e6ebf1 !important;
        border-left: none !important;
        border-right: none !important;
      }

  .ant-table-thead th.ant-table-column-has-sorters {
    background: #f2f4f7 !important;
  }

  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    background-color: #f2f4f7 !important;
  }

  /* Update borders for first and last header cells */
  .ant-table-container table > thead > tr:first-child th:first-child {
    border-left: 1px solid #e6ebf1 !important;
    border-top-left-radius: 8px;
  }

  .ant-table-container table > thead > tr:first-child th:last-child {
    border-right: 1px solid #e6ebf1 !important;
    border-top-right-radius: 8px;
  }

      /* Update body cell borders - remove old and apply new */
      .ant-table-tbody > tr > td {
        padding: 8px !important;
        border-bottom: 1px solid #e6ebf1 !important;
        border-left: none !important;
        border-right: none !important;
        vertical-align: middle !important;
      }

  .ant-table-tbody > tr > td:first-child {
    border-left: 1px solid #e6ebf1 !important;
  }

  .ant-table-tbody > tr > td:last-child {
    border-right: 1px solid #e6ebf1 !important;
  }

  /* Update last row borders */
  .ant-table-tbody > tr:last-child > td:first-child {
    border-bottom-left-radius: 8px;
  }

  .ant-table-tbody > tr:last-child > td:last-child {
    border-bottom-right-radius: 8px;
  }

  .ant-table-column-sorter {
    margin-left: 8px;
    margin-top: 5px;
    display: inline-flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
  }

  .ant-table-column-sorter-inner {
    display: flex !important;
    flex-direction: column !important;
    align-items: center;
    gap: 2px;
    margin: 0 !important;
  }

  .ant-table-column-sorter-up,
  .ant-table-column-sorter-down {
    svg {
      display: none;
    }
    width: 0 !important;
    height: 0 !important;
    border-left: 4px solid transparent !important;
    border-right: 4px solid transparent !important;
    transition: all 0.2s ease;
    margin: 0 !important;
    position: static !important;
    transform: none !important;
    top: auto !important;
  }
  
  .ant-table-column-sorter-up:after,
  .ant-table-column-sorter-down:after {
    content: none !important;
    display: none !important;
  }

  /* Gray up arrow by default */
  .ant-table-column-sorter-up {
    border-bottom: 5px solid ${GRAY_300} !important;
    border-top: none !important;
  }

  /* Gray down arrow by default */
  .ant-table-column-sorter-down {
    border-top: 5px solid ${GRAY_300} !important;
    border-bottom: none !important;
  }

  /* Default hover state - up arrow darkens (for ascending sort - "Click to sort ascending") */
  .ant-table-thead th.ant-table-column-has-sorters:not([aria-sort]):hover .ant-table-column-sorter-up:not(.active) {
    border-bottom: 5px solid ${GRAY_400} !important;
  }

  .ant-table-thead th.ant-table-column-has-sorters:not([aria-sort]):hover .ant-table-column-sorter-down:not(.active) {
    border-top: 5px solid ${GRAY_300} !important;
  }

  /* When sorted ascending, hovering shows darker down arrow (for descending sort - "Click to sort descending") */
  .ant-table-thead
    th.ant-table-column-has-sorters[aria-sort="ascending"]:hover
    .ant-table-column-sorter-up:not(.active) {
    border-bottom: 5px solid ${GRAY_300} !important;
  }

  .ant-table-thead
    th.ant-table-column-has-sorters[aria-sort="ascending"]:hover
    .ant-table-column-sorter-down:not(.active) {
    border-top: 5px solid ${GRAY_400} !important;
  }

  /* When sorted descending, hovering shows NO colored arrows (for cancel sorting - "Click to cancel sorting") */
  .ant-table-thead
    th.ant-table-column-has-sorters[aria-sort="descending"]:hover
    .ant-table-column-sorter-up:not(.active) {
    border-bottom: 5px solid ${GRAY_300} !important;
  }

  .ant-table-thead
    th.ant-table-column-has-sorters[aria-sort="descending"]:hover
    .ant-table-column-sorter-down:not(.active) {
    border-top: 5px solid ${GRAY_300} !important;
  }

  /* Blue up arrow when ascending sort is active */
  .ant-table-column-sorter-up.active {
    border-bottom: 5px solid ${PRIMARY_600} !important;
    border-top: none !important;
    border-left: 4px solid transparent !important;
    border-right: 4px solid transparent !important;
  }

  /* Blue down arrow when descending sort is active */
  .ant-table-column-sorter-down.active {
    border-top: 5px solid ${PRIMARY_600} !important;
    border-bottom: none !important;
    border-left: 4px solid transparent !important;
    border-right: 4px solid transparent !important;
  }
`;
